import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";

export default {
    name: "dictionaryManagement",
    components: { iTable, IPagination },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            brandId: '',
            brandName: '',
            BrandList: [],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "name",
                    label: this.$t('common.model'),
                    align: "center",
                },
                {
                    prop: "remarks",
                    label: this.$t('common.remark'),
                    align: "center",
                }
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            diaBtn: '',
            rules: {},
            form: {
                name: '',
                brandSort: ''
            },
            dialogModelFormVisible: false,
            diaModelTitle: '',
            btnModel: '',
            ModelRules: {},
            ModelForm: {
                name: '',
                remarks: '',
            },
            selected: [],
            id: '',
            brandSort: ''
        }
    },
    created() {
        this.getBrand()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        getBrand() {
            this.$store.dispatch('dictionaryManagement/GET_SELECTALLBRAND', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.BrandList = res.data.data
                        this.brandId = res.data.data[0].id
                        this.brandName = res.data.data[0].name
                        this.brandSort = res.data.data[0].brandSort
                        this.getModel()
                    }
                }
            }).catch(err => { })
        },
        getModel() {
            let param = {
                brandId: this.brandId,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            this.$store.dispatch('dictionaryManagement/GET_SELECTALLTYPE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        ChangModel(val) {
            console.log(val)
            this.brandId = val
            let value = this.BrandList.find((item) => item.id == val);
            this.brandName = value.name
            this.brandSort = value.brandSort
            this.getModel()
        },
        addBrand() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('PlatformSettings.form.addBrand')
            this.diaBtn = 'add'
        },
        editBrand() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('PlatformSettings.form.editBrand')
            this.diaBtn = 'edit'
            this.form.name = this.brandName
            this.form.brandSort = this.brandSort
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        name: this.form.name,
                        brandSort: this.form.brandSort,
                        companyId: sessionStorage.getItem("companyId")
                    }
                    if (this.diaBtn == 'add') {
                        this.$store.dispatch('dictionaryManagement/GET_INSERTBRAND', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('PlatformSettings.form.addBrandSuccess'))
                                this.dialogFormVisible = false;
                                this.getBrand();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })

                    } else {
                        param.id = this.brandId
                        this.$store.dispatch('dictionaryManagement/GET_UPDATEBRAND', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('PlatformSettings.form.editBrandSuccess'))
                                this.dialogFormVisible = false;
                                this.getBrand();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })

                    }
                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                name: '',
                brandSort: ''
            }
        },
        closeDia() {
            this.form = {
                name: '',
                brandSort: ''
            }
            this.dialogFormVisible = false;
        },
        deleteBrand() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { id: this.brandId }
                    this.$store.dispatch('dictionaryManagement/GET_DELETEBRAND', param).then(response => {
                        if (response.data.code == 200) {
                            this.getBrand()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        addModel() {
            this.dialogModelFormVisible = true
            this.diaModelTitle = this.$t('common.btn.add')
            this.btnModel = 'add'
        },
        editModel() {
            this.dialogModelFormVisible = true
            this.diaModelTitle = this.$t('common.btn.edit')
            this.btnModel = 'edit'
            this.ModelForm.name = this.selected[0].name
            this.ModelForm.remarks = this.selected[0].remarks
        },
        submitModelForm(ModelFormName) {
            this.$refs[ModelFormName].validate((valid) => {
                if (valid) {
                    let param = {
                        brandId: this.brandId,
                        name: this.ModelForm.name,
                        remarks: this.ModelForm.remarks,
                    }
                    if (this.btnModel == 'add') {
                        this.$store.dispatch('dictionaryManagement/GET_INSERTBRANDTYPE', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('PlatformSettings.form.addTypeSuccess'))
                                this.dialogModelFormVisible = false;
                                this.getModel();
                                this.closeModelDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        param.id = this.selected[0].id
                        this.$store.dispatch('dictionaryManagement/GET_UPDATEBRANDTYPE', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('PlatformSettings.form.editTypeSuccess'))
                                this.dialogModelFormVisible = false;
                                this.getModel();
                                this.closeModelDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }


                } else {
                    return false;
                }
            });
        },
        cancleModel(ModelFormName) {
            this.dialogModelFormVisible = false;
            this.ModelForm = {
                name: '',
                remarks: ''
            }
        },
        closeModelDia() {
            this.ModelForm = {
                name: '',
                remarks: ''
            }
            this.dialogModelFormVisible = false;
        },
        deleteModel() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { id: this.selected[0].id }
                    this.$store.dispatch('dictionaryManagement/GET_DELETEBRANDTYPE', param).then(response => {
                        if (response.data.code == 200) {
                            this.getModel()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getModel();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}